"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractModelFactory_1 = require("./AbstractModelFactory");
/**
 * Further extends the AbstractFactory to add widget generation capability.
 */
class AbstractReactFactory extends AbstractModelFactory_1.AbstractModelFactory {
}
exports.AbstractReactFactory = AbstractReactFactory;
//# sourceMappingURL=AbstractReactFactory.js.map